var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('div',{staticClass:"view"},[_c('keep-alive',{attrs:{"include":"Join"}},[_c('router-view')],1)],1),_vm._v(" "),_c('nav-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.navBar),expression:"navBar"}]})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6a63c6e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/App/App.vue
// module id = null
// module chunks = 